import { render, staticRenderFns } from "./set-power.vue?vue&type=template&id=3fd52f7c&"
import script from "./set-power.vue?vue&type=script&lang=ts&"
export * from "./set-power.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports